import { makeStyles } from "tss-react/mui";

const useSearcFieldStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: "8px 12px",
    border: `1px solid ${theme.palette.strokes.defaultGrey}`,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.surface.light,
    borderBottom: "none",
  },
  top: {
    fontSize: "0.75rem",
    color: theme.palette.text.secondary,
  },
  bottom: {
    color: theme.palette.text.primary,
    overflowWrap: "break-word",
  },
}));

export default useSearcFieldStyles;
